import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import {SingleValue} from 'react-select';
import InputSelect from '../../../../common/components/ui/InputSelect';
import styles from './FieldStatus.module.scss';

type Option = {label: string, value: number};

const FieldStatus = () => {
  const [field, meta, helpersStatus] = useField({name: 'status'});
  const {formatMessage} = useIntl();
  const statuses = [
    {label: formatMessage({id: 'invoices-col-status-1', defaultMessage: 'Open'}), value: 1},
    {label: formatMessage({id: 'invoices-col-status-2', defaultMessage: 'Closed'}), value: 2},
    {label: formatMessage({id: 'invoices-col-status-3', defaultMessage: 'Converted to tax invoice'}), value: 3},
    {label: formatMessage({id: 'invoices-col-status-4', defaultMessage: 'Converted to tax invoice receipt'}), value: 4},
  ];

  const placeholderLabel = formatMessage({id: 'invoices-col-status', defaultMessage: 'Status'});

  const handleChange = (status: SingleValue<Option>) => helpersStatus.setValue(status?.value || null);
  const [selectedValue] = statuses.filter(option => option.value === field.value);

  return (
    <div className={styles.selectContainer}>
      <InputSelect
        <Option>
        {...field}
        {...meta}
        id={field.name}
        value={selectedValue}
        placeholder={placeholderLabel}
        options={statuses}
        onChange={handleChange}
      />
    </div>
  );
};

export default FieldStatus;